import { render, staticRenderFns } from "./message-assistant-ask.vue?vue&type=template&id=09684299"
import script from "./message-assistant-ask.vue?vue&type=script&lang=js"
export * from "./message-assistant-ask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports